export const search = {
  searchType: "Search Type",
  searchByKeyword: "Search by keyword",
  searchByCategory: "Search by category",
  typeHere: "Type here",
  // ===============================================================
};
